import { render, staticRenderFns } from "./TenantController.vue?vue&type=template&id=6336bc4e&"
import script from "./TenantController.vue?vue&type=script&lang=js&"
export * from "./TenantController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports